import styled from 'styled-components';
import { Link } from '@reach/router';

export default styled(Link)`
  font-size: 0.8rem;
`;
